<template>
    <div ref="table"
        class="md major-table"
        :class="[headerTop > 0? 'is-header-fixed': '', focus? 'focus': '', drop? 'is-drop': '', click? 'has-click': '', haveBorder? 'is-border-display': '']"
        @mouseleave="removeActive"
    >
        <table border="0">
            <tbody>
                <tr :style="'transform: translateY('+ headerTop +'px);'" ref="tableHeader" class="is-header">
                    <th
                        v-if="drop"
                        class="drop-th"
                        :class="[column === 'drop'? 'is-active': '']"
                        @mouseenter="changeColumn('drop')"
                    >
                        <div class="in" style="text-align-last: center">
                            <a v-if="dropString">{{ dropString }}</a>
                            <a v-else>拖曳</a>
                        </div>
                    </th>
                    <th
                        v-if="typeof check === 'string' && check !== ''"
                        class="check-th"
                        :class="[column === 'check'? 'is-active': '']"
                        @mouseenter="changeColumn('check')"
                    >
                        <div class="in" v-if="checkMultiple">
                            <div v-if="checkGlobal" class="cp input checkbox dot-only">
                                <input type="checkbox" checked>
                                <label for @click="changeAllChecked(content, check, false)"></label>
                            </div>
                            <div v-else class="cp input checkbox dot-only">
                                <input type="checkbox">
                                <label for @click="changeAllChecked(content, check, true)"></label>
                            </div>
                        </div>
                        <div class="in" v-else>勾選</div>
                    </th>
                    <template v-for="$title in title">
                        <th
                            class="is-changed"
                            v-if="sortable && $title.sortable"
                            :class="[$title.sort === 'asc'? 'is-down':'', $title.sort === 'desc'? 'is-up':'', column === $title.prop? 'is-active': '']"
                            :data-prop="$title.prop"
                            :data-showType="$title.showtype"
                            :data-inputType="$title.inputtype"
                            :key="'title-'+ $title.prop"
                            @mouseenter="changeColumn(title.prop)"
                        >
                            <div class="in">
                                <a
                                    :style="[$title.thcolor? 'color: '+ $title.thcolor: '']"
                                    @click.prevent="sortByKey($title.prop)"
                                    v-html="$title.caption"
                                ></a>
                            </div>
                        </th>
                        <th
                            v-else
                            :class="column === $title.prop? 'is-active': ''"
                            :data-prop="$title.prop"
                            :data-showType="$title.showtype"
                            :data-inputType="$title.inputtype"
                            :key="'title-'+ $title.prop"
                            @mouseenter="changeColumn($title.prop)"
                        >
                            <div class="in">
                                <a
                                    :style="[$title.thcolor? 'color: '+ $title.thcolor: '']"
                                    v-html="$title.caption"
                                ></a>
                            </div>
                        </th>
                    </template>
                </tr>
                <template v-for="$content in content">
                    <tr
                        :key="'content-'+ $content.sn"
                        :class="[$content.sn === row? 'is-active': '', catchNodeSn == $content.sn? 'is-border-'+ away :'', $content.new? 'is-new': '']"
                        :draggable="drop"

                        @dragstart="sendStartDropStatus($content, $event)"
                        @dragend="sendEndDropStatus($content, $event)"
                        @mouseenter="changeRow($content)"
                    >
                        <td
                            v-if="drop"
                            class="drop-td"
                            :class="[column === 'drop'? 'is-active': '']"
                            title="拖曳"
                            @mouseenter="changeColumn('drop')"
                        >
                            <div class="in">
                                <div class="sensor">
                                    <div class="top"
                                        :class="catchNodeSn === $content.sn && away === 'top'? 'is-drop': ''"
                                        @drop.prevent="sendChangeData('top', $content, $event)"
                                        @dragover.prevent="sendMovingStart('top', $content, $event)"
                                        @dragexit.prevent="sendMovingEnd"
                                        @dragleave.prevent="sendMovingEnd"
                                    ></div>
                                    <div class="bottom"
                                        :class="catchNodeSn === $content.sn && away === 'bottom'? 'is-drop': ''"
                                        @drop.prevent="sendChangeData('bottom', $content, $event)"
                                        @dragover.prevent="sendMovingStart('bottom', $content, $event)"
                                        @dragexit.prevent="sendMovingEnd"
                                        @dragleave.prevent="sendMovingEnd"
                                    ></div>
                                </div>
                                <a></a>
                            </div>
                        </td>
                        <td
                            v-if="check !== ''"
                            :data-type="check"
                            title="勾選"
                            class="check-td"
                            :class="[column === 'check'? 'is-active': '']"
                            :draggable="drop"
                            @dragstart.stop.prevent
                            @mouseenter="changeColumn('check')"
                        >
                            <div class="in" v-if="typeof $content[check] === 'boolean'">
                                <!-- <div class="table-checkbox">
                                    <input type="checkbox" v-model="$content[check]">
                                </div> -->
                                <div v-if="$content[check] === true" class="cp input checkbox dot-only">
                                    <input type="checkbox" checked>
                                    <label for @click="changeChecked($content, check, false)"></label>
                                </div>
                                <div v-else class="cp input checkbox dot-only">
                                    <input type="checkbox">
                                    <label for @click="changeChecked($content, check, true)"></label>
                                </div>
                            </div>
                            <div class="in" v-else>
                                <div class="cp input checkbox dot-only" disabled>
                                    <input type="checkbox">
                                    <label></label>
                                </div>
                            </div>
                        </td>
                        <template v-for="$title in title">
                            <td
                                :data-type="typeof $content[$title.prop]"
                                :title="$title.caption"
                                :class="[column === $title.prop? 'is-active': '']"
                                :key="$content.sn +'-'+ $title.prop"
                                :draggable="drop"
                                @dragstart.stop.prevent
                                @mouseenter="changeColumn($title.prop)"
                                @click="action($title.prop, $content[$title.prop], $content)"
                            >
                                <!-- btns -->
                                <div
                                    class="in"
                                    v-if="$title.showtype === 'btns'"
                                >
                                    <cpBtn v-for="item in $content[$title.prop]"
                                        :themes="item.themes? item.themes: ''"
                                        :icon="item.icon? item.icon: ''"
                                        :key="item.func"
                                        :title="item.title || item.text"
                                        :text="item.text"
                                        :disabled="!item.func"
                                        :extendClass="item.extendClass"
                                        @click="sendFuncEvent(item.func, $content)"
                                    ></cpBtn>
                                </div>
                                <!-- input -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'input'"
                                >
                                    <div
                                        v-if="$title.inputtype === 'color'"
                                        class="cp input color"
                                        :class="[errors.has('mesh')? 'is-error': '']"
                                        :data-error="errors.first('mesh')"
                                    >
                                        <input
                                            :disabled="$title.disabled"
                                            type="color"
                                            @change="updateTableData($content)"
                                            v-model="$content[$title.prop]"
                                        >
                                    </div>
                                    <div
                                        v-else
                                        class="cp input"
                                        :class="[errors.has($content.sn +'-'+ $title.prop)? 'is-error': '',$title.inputtype === 'number'? 'number': 'text' ]"
                                        :data-error="errors.first($content.sn +'-'+ $title.prop)"
                                    >
                                        <input
                                            :disabled="$title.disabled"
                                            :type="$title.inputtype === 'number'? 'number': 'text'"
                                            :style="{
                                                width: $title.inputWidth || 'auto'
                                            }"
                                            @change="updateTableData($content)"
                                            v-model="$content[$title.prop]"
                                            v-validate="$title.validate"
                                            :name="$content.sn +'-'+ $title.prop"
                                        >
                                    </div>
                                </div>
                                <!-- select -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'select'"
                                >
                                    <div
                                        v-if="typeof $title.options === 'object'"
                                        class="cp input select"
                                        :class="[errors.has($content.sn +'-'+ $title.prop)? 'is-error': '']"
                                        :data-error="errors.first($content.sn +'-'+ $title.prop)"
                                    >
                                        <select
                                            v-if="Array.isArray($title.options)"
                                            :disabled="$title.disabled"
                                            :style="{
                                                width: $title.inputWidth || 'auto'
                                            }"
                                            @change="updateTableData($content)"
                                            v-model="$content[$title.prop]"
                                            v-validate="$title.validate"
                                            :name="$content.sn +'-'+ $title.prop"
                                        >
                                            <option value="">請選擇</option>
                                            <option v-for="item in $title.options" :key="item" :value="item">{{ item }}</option>
                                        </select>
                                        <select
                                            v-else
                                            :disabled="$title.disabled"
                                            :style="{
                                                width: $title.inputWidth || 'auto'
                                            }"
                                            @change="updateTableData($content)"
                                            v-model="$content[$title.prop]"
                                            v-validate="$title.validate"
                                            :name="$content.sn +'-'+ $title.prop"
                                        >
                                            <option value="">請選擇</option>
                                            <option  v-for="(key, value) in $title.options" :key="value" :value="value">{{ key }}</option>
                                        </select>
                                    </div>
                                    <div
                                        v-else
                                        class="cp input text"
                                        :class="[errors.has($content.sn +'-'+ $title.prop)? 'is-error': '']"
                                        :data-error="errors.first($content.sn +'-'+ $title.prop)"
                                    >
                                        <input
                                            type="text"
                                            :disabled="$title.disabled"
                                            :style="{
                                                width: $title.inputWidth || 'auto'
                                            }"
                                            @change="updateTableData($content)"
                                            v-model="$content[$title.prop]"
                                            v-validate="$title.validate"
                                            :name="$content.sn +'-'+ $title.prop"
                                        >
                                    </div>
                                </div>
                                <!-- text -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'text'"
                                >{{ textFormatter($content[$title.prop]) }}</div>
                                <!-- number -->
                                <div
                                    class="in is-number"
                                    v-else-if="$title.showtype === 'number'"
                                >{{ $okaTool.numberToStringFormat($content[$title.prop]) }}</div>
                                <!-- label -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'label'"
                                >
                                    <cpLabel
                                        extendClass="is-tag"
                                        :themes="getSetValue('themes', $title, $content, $title.prop)? getSetValue('themes', $title, $content, $title.prop): 'is-major'"
                                        :text="textFormatter($content[$title.prop])"
                                    ></cpLabel>
                                </div>
                                <!-- boolean -->
                                <div
                                    class="in is-unmobile-center"
                                    v-else-if="$title.showtype === 'boolean'"
                                >
                                    <cpLabel
                                        v-if="$content[$title.prop] !== '' && $content[$title.prop] !== undefined"
                                        extendClass="is-circle"
                                        :icon="[$content[$title.prop] === true? 'done': '', $content[$title.prop] === false? 'close': '', $content[$title.prop] === null? 'pause': '', $content[$title.prop] !== undefined? 'is-'+ $content[$title.prop]: '']"
                                    ></cpLabel>
                                </div>
                                <!-- color -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'color'"
                                >
                                    <div
                                        v-if="$content[$title.prop]"
                                        class="cp input color"
                                    >
                                        <input type="color" :value="$content[$title.prop]" disabled>
                                    </div>
                                </div>
                                <!-- year -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'year'"
                                >{{
                                    $okaTool.timeInterval({
                                        time: $content[$title.prop],
                                        unit: 'date'
                                    }).y
                                }}</div>
                                <!-- month -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'month'"
                                >{{
                                    $okaTool.timeInterval({
                                        time: $content[$title.prop],
                                        unit: 'date'
                                    }).ym.replace(/\-/g, '/')
                                }}</div>
                                <!-- date -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'date'"
                                >{{
                                    $okaTool.timeInterval({
                                        time: $content[$title.prop],
                                        unit: 'date'
                                    }).ymd.replace(/\-/g, '/')
                                }}</div>
                                <!-- hours -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'hours'"
                                >{{
                                    $okaTool.timeInterval({
                                        time: $content[$title.prop],
                                        unit: 'date'
                                    }).ymdh.replace(/\-/g, '/') +':00'
                                }}</div>
                                <!-- minutes -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'minutes'"
                                >{{
                                    $okaTool.timeInterval({
                                        time: $content[$title.prop],
                                        unit: 'date'
                                    }).ymdhm.replace(/\-/g, '/')
                                }}</div>
                                <!-- time -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'time'"
                                >{{
                                    $okaTool.timeInterval({
                                        time: $content[$title.prop],
                                        unit: 'date'
                                    }).t
                                }}</div>
                                <!-- html -->
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'html' && title.inputtype === 'color' && $content[$title.prop]"
                                >
                                    <input
                                        type="color"
                                        style="cursor: default;"
                                        :value="$content[$title.prop]"
                                        disabled
                                    >
                                </div>
                                <div
                                    class="in"
                                    v-else-if="$title.showtype === 'html'"
                                    v-html="$content[$title.prop]"
                                ></div>
                                <!-- 其他就當作文字格式化的 html -->
                                <div
                                    class="in"
                                    v-else
                                    v-html="textFormatter($content[$title.prop])"
                                ></div>
                            </td>
                        </template>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    import cpBtn from '@/components/cpBtn'
    import cpLabel from '@/components/cpLabel'

    import { mapMutations } from 'vuex'

    export default {
        components: {
            cpBtn,
            cpLabel,
        },
        props: {
            title: {
                type: Array,
                require: true
            },
            content: {
                type: Array,
                require: true
            },
            fixedHeader: {
                type: Boolean,
                require: true
            },
            click: {
                type: Boolean,
                require: true
            },
            drop: {
                type: Boolean,
                require: true
            },
            check: {
                type: String,
                require: true
            },
            checkMultiple: {
                type: Boolean,
                require: true
            },
            focus: {
                type: Boolean,
                require: true
            },
            sortable: {
                type: Boolean,
                require: true
            },
            haveBorder: {
                type: Boolean,
                require: true
            },
            away: {
                type: String,
                require: true
            },
            catchNodeSn: {
                require: true
            },
            dropString: {
                type: String,
                require: false
            },
        },
        data: function(){

            return {
                headerTop: 0,
                row: '',
                column: '',
                checkGlobal: false,
                id: 'table-'+ this.$okaTool.getUUID(),
            }
        },
        methods: {
            ...mapMutations([
                'globalScrollFuncQueuePush',
                'globalScrollFuncQueueClear',
            ]),
            validate: function() {
                return this.$validator.validate().then(result => {
                    return result;
                });
            },
            getSetValue: function(key, title, item, prop){
                let $extend = item.extend || {}

                if( $extend[key] && $extend[key][prop] !== undefined ){
                    return $extend[key][prop]
                }else {
                    return title[key]
                }
            },
            textFormatter: function(text){
                return this.$okaTool.textFormatter(text);
            },
            changeAllChecked: function(content, check, boolean){

                content.forEach(item => {

                    if( typeof item[check] === 'boolean' ) {
                        item[check] = boolean;
                    }
                });

                this.checkChecked();
            },
            changeChecked: function(content, check, boolean){

                if( !this.checkMultiple && boolean ) { //如果是單選並且打勾，那就要先把其他 true 的通通關掉

                   this.content.forEach(item => {
                       
                        if( item[check] ) {
                            this.$set(item, check, false);
                        }
                    });
                }

                this.$set(content, check, boolean);

                this.checkChecked();
            },
            checkChecked: function(){
                let _checkGlobal = false,
                    $content = this.content,
                    _key = this.check;

                if( _key !== '' && $content.length > 0 ) {

                    _checkGlobal = $content.every(item => {
                        return typeof item[_key] !== 'boolean' || item[_key] === true;
                    });
                }

                this.$set(this, 'checkGlobal', _checkGlobal);
            },
            sortByKey: function(_key){
               this.$emit('sendEvent', 'sortByKey', _key);
            },
            updateTableData: function(opt){
               this.$emit('sendEvent', 'updateTableData', opt);
            },
            action: function(title, value, content){

                if( this.click ) {
                    this.$emit('sendEvent', 'tableClick', title, value, content);
                }
            },
            removeActive: function(){
                this.$set(this, 'row', -1);
                this.$set(this, 'column', -1);
            },
            changeRow: function(opt){
                let _row;

                if( typeof opt === 'number' || typeof opt === 'string' ) {
                    _row = opt;
                }else if( typeof opt === 'object' && opt.sn ) {
                    _row = opt.sn;

                    if( opt.new ) {
                        delete opt.new;
                    }
                }

                this.row = _row;
            },
            changeColumn: function(prop){
                this.column = prop;
            },
            getTop: function(node){
                let $node = node,
                    _top = 0;

                if( $node ){
                    _top = node.offsetTop;

                    let $parent = node.offsetParent;

                    while ($parent){
                        _top += $parent.offsetTop;
                        $parent = $parent.offsetParent;
                    }

                    return _top;
                }else {
                    return 0;
                }
            },
            setFixed: function(){

                if( this.fixedHeader ) {
                    let $loPage = document.querySelector('.lo.page'),
                        $loPage_t = this.getTop($loPage);

                    let _scroll = window.pageYOffset;

                    let $table = this.$refs.table,
                        $header = this.$refs.tableHeader;

                    if( $table && $header ){
                        let $table_t = this.getTop($table),
                            $table_h = $table.clientHeight,
                            $header_h = $header.clientHeight;

                        let _interval = $table_t - $loPage_t;

                        let _top = 0;

                        if( _scroll > _interval && _scroll < _interval + $table_h - $header_h ){
                            _top = _scroll - _interval;
                        }

                        this.headerTop = _top;
                    }
                }
            },
            sendStartDropStatus: function(obj, e){
                e.dataTransfer.setData('Text', ''); //firefox

                this.$emit('sendEvent', 'startDropStatus', {
                    obj: obj,
                    node: e.target
                });
            },
            sendEndDropStatus: function(obj, e){

                this.$emit('sendEvent', 'endDropStatus', {
                    obj: obj,
                    node: e.target
                });
            },
            sendChangeData: function(away, obj, e){

                this.$emit('sendEvent', 'changeData', {
                    away: away,
                    obj: obj,
                    node: e.target //節點
                });
            },
            sendMovingStart: function(away, obj, e){ //滑入物件加 class 改變顏色
                this.$emit('sendEvent', 'movingStart', {
                    away: away,
                    obj: obj,
                    node: e.target //節點
                });
            },
            sendMovingEnd: function(e){ //滑入物件刪除 class 改變顏色
                this.$emit('sendEvent', 'movingEnd', e.target);
            },
            sendFuncEvent: function(func, obj){
                this.$emit('sendEvent', 'sendFuncEvent', func, obj);
            }
        },
        updated: function(){
            this.checkChecked();
        },
        created: function(){
            this.globalScrollFuncQueuePush({
                id: this.id,
                func: this.setFixed
            });
        },
        destroyed: function(){
            this.globalScrollFuncQueueClear(this.id);
        }
    }
</script>

<style scoped lang="scss">

    .md.major-table {
        th{
            line-height: $interval-xxl
        }
        td{
            line-height: $interval-xxl;
        }
    }
</style>
